import React from "react";

const About = () => {
  return (
    <div className="container mx-auto py-10 px-10">
      <div className="grid lg:grid-cols-2 gap-5">
        <div className="justify-items-center">
          <img src="/assets/img/avtar.png" alt="Avatar" />
        </div>
        <div>
          <h1 className="text-2xl font-bold"> Hello, I’m Naina Joshi</h1>
          <p className="mt-5">
            Hello! I’m Naina Joshi, a dedicated UX designer based in the vibrant
            city of Jaipur, Rajasthan, India. As a first-year college student
            who has recently earned a Google UX Design Certificate from
            Coursera, I’m eager to blend creativity with empathy in my work.{" "}
            <br />
            <br />
            My design philosophy focuses on user-first principles and making
            technology effortlessly understandable. <br />
            <br />
            Outside of my design work, I love to draw, keep up with fitness, and
            explore different worlds through reading.
          </p>
          <div className="text-center mt-5">
            <a
              href="/assets/img/RESUME.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-blue-200 hover:bg-h-color hover:text-white px-8 py-2 rounded-lg font-bold uppercase"
            >
              Resume
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
